// 22.01.19
import { reduxForm, FormSection } from "redux-form";
import * as React from "react";
import { Grid } from "@material-ui/core";
// import {  FlexGridItem, FlexTextField, CheckBoxField, SelectField, DateTimeField, ConditionalField, DisableForRoles, TextArea, required } from './form_utility';
import {
  FlexGridItem,
  FlexTextField,
  CheckBoxField,
  TextArea,
  HideForRoles,
  DisableForRoles,
  maxLength200,
  maxLength100,
} from "./form_utility";
import { connect } from "react-redux";
import {
  actionSaveAttachmentData,
  actionDownloadAttachment,
  actionDeleteAttachment,
} from "src/actions/detail";
import AttachmentContainer from "src/components/common/attachment-container";
import { FORM_TYPE_INVENTORY, FORM_ERROR_MESSAGE } from "src/constants/data.js";
import { UserRoles, CaseType } from "src/constants/api";
import { getStringAfterSubstring, getStringBeforeSubstring } from "../../utils";
import { openToaster, closeToaster } from "src/actions/common";

class InventoryFormComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const {
      handleSubmit,
      handleChange,
      saveAttachmentData,
      deleteAttachment,
      downloadAttachment,
      attachmentData,
      uniqueId,
      isNewCase,
      submitFailed,
      invalid,
      openToaster,
      closeToaster,
      isToasterVisible,
    } = this.props;

    const disableForm = this.disableForm();
    if (submitFailed && invalid) {
      openToaster(FORM_ERROR_MESSAGE, false);
    } else if (!invalid && isToasterVisible) {
      closeToaster();
    }
    return (
      <form onSubmit={handleSubmit} onChange={handleChange}>
        <FormSection name="shipments[0]">
          <Grid style={{ paddingTop: "25px" }} container={true} spacing={2}>
            <FlexGridItem xs={12}>
              <TextArea
                name="description"
                label="Description of loss"
                disabled={disableForm}
              />
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <FlexTextField
                name="warehouseName"
                label="Warehouse name"
                disabled={disableForm}
                validate={[maxLength200]}
              />
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <FlexTextField
                name="storageLocation"
                label="Storage location"
                disabled={disableForm}
                validate={[maxLength200]}
              />
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <FlexTextField
                name="plantNo"
                label="Plant No"
                disabled={disableForm}
                validate={[maxLength100]}
              />
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <FlexTextField
                name="address"
                label="Address"
                disabled={disableForm}
                validate={[maxLength200]}
              />
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <FlexTextField
                name="insurancePostingReference"
                label="Insurance posting reference"
                disabled={disableForm}
              />
              <HideForRoles roles={[UserRoles.Partner, UserRoles.UNICEF]}>
                <DisableForRoles
                  roles={[UserRoles.FMC, UserRoles.QMU]}
                  isnewcase={isNewCase}
                  disableField={disableForm}
                >
                  <FlexTextField
                    name="actualInsuredValues"
                    label="Actual insured values"
                  />
                </DisableForRoles>
              </HideForRoles>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <HideForRoles roles={[UserRoles.Partner, UserRoles.UNICEF]}>
                <DisableForRoles
                  roles={[UserRoles.FMC, UserRoles.QMU]}
                  isnewcase={isNewCase}
                  disableField={disableForm}
                >
                  <FlexTextField name="premium" label="Premium" />
                </DisableForRoles>
              </HideForRoles>

              <FlexTextField
                name="totalClaimsValuesSupplies"
                label="Total claims value supplies"
                disabled={disableForm}
              />
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <HideForRoles roles={[UserRoles.Partner, UserRoles.UNICEF]}>
                <DisableForRoles
                  roles={[UserRoles.FMC, UserRoles.QMU]}
                  isnewcase={isNewCase}
                  disableField={disableForm}
                >
                  <FlexTextField
                    name="deductibleUnderThePolicy"
                    label="Deductible under the policy"
                  />
                </DisableForRoles>
              </HideForRoles>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <HideForRoles roles={[UserRoles.FMC, UserRoles.Partner]}>
                <DisableForRoles
                  roles={[UserRoles.UNICEF, UserRoles.QMU]}
                  isnewcase={isNewCase}
                  disableField={disableForm}
                >
                  <React.Fragment>
                    <div style={{ paddingLeft: "12px", paddingTop: "12px" }}>
                      <CheckBoxField name="psb" label="PSB" />
                    </div>
                    <p>
                      PSB - Confirm that for all cases of shortage/loss/damage
                      the records in Vision has been adjusted and the items are
                      moved to the PSB bin (099) in Vision.
                    </p>
                  </React.Fragment>
                </DisableForRoles>
              </HideForRoles>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <HideForRoles roles={[UserRoles.FMC, UserRoles.Partner]}>
                <DisableForRoles
                  roles={[UserRoles.UNICEF, UserRoles.QMU]}
                  isnewcase={isNewCase}
                  disableField={disableForm}
                >
                  <FlexTextField
                    name="psbcomments"
                    label="If No please comment"
                  />
                </DisableForRoles>
              </HideForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <HideForRoles roles={[UserRoles.Partner, UserRoles.UNICEF]}>
                <DisableForRoles
                  roles={[UserRoles.FMC, UserRoles.QMU]}
                  isnewcase={isNewCase}
                  disableField={disableForm}
                >
                  <FlexTextField name="recoveryValue" label="Recovery value" />
                </DisableForRoles>
              </HideForRoles>
            </FlexGridItem>
            <AttachmentContainer
              label="Attachments"
              uniqueId={uniqueId}
              onSave={saveAttachmentData}
              attachment={attachmentData}
              download={downloadAttachment}
              remove={deleteAttachment}
              type={FORM_TYPE_INVENTORY}
              disabled={disableForm}
              {...this.props}
            />
          </Grid>{" "}
        </FormSection>
      </form>
    );
  }

  private disableForm = () => {
    const {
      caseData,
      currentRoleId,
      allowEdit,
      isNewCase,
      mainForm,
      isLockForEdit,
      currentUsername,
    } = this.props;
    let disableForm = false;
    const formValues = mainForm.mainForm.values;
    if (!allowEdit) {
      disableForm = true;
    } else if (!isNewCase && caseData) {
      if (
        currentRoleId === UserRoles.QMU &&
        (formValues.caseType === CaseType.Complaint ||
          formValues.caseType === CaseType.ComplaintClaim ||
          formValues.caseType === CaseType.Claim)
      ) {
        disableForm = true;
      } else if (
        currentRoleId === UserRoles.INS &&
        formValues.caseType === CaseType.Complaint
      ) {
        disableForm = true;
      } else if (currentRoleId === UserRoles.UNICEF && isLockForEdit) {
        disableForm = true;
      } else if (
        currentRoleId === UserRoles.Solution_Owner ||
        currentRoleId === UserRoles.Solution_Team
      ) {
        // Get username who created the case
        let createdBy = mainForm.mainForm.values.createdBy;
        createdBy = getStringAfterSubstring(createdBy, "(");
        createdBy = getStringBeforeSubstring(createdBy, ")").trim();

        if (currentUsername !== createdBy || isLockForEdit) {
          disableForm = true;
        }
      }
    }

    return disableForm;
  };
}
// const InventoryFormComponent = props => {};

// mainForm is the name of the form object for the Redux form state store.
// enableReinitialize enables changes to initial data to render.
// keepDirtyOnReinitialize enables to keep edited data on reinitialize.
// destroyOnUnmount enables that data is kept when changing tabs.

const InventoryForm = reduxForm({
  form: "mainForm",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  // @ts-ignore
})(InventoryFormComponent);

function mapStateToProps(state: any, ownProps: any) {
  return {
    mainForm: state.form,
    route: state.routing,
    attachmentData: state.detail.attachmentDataInventory,
    caseData: state.detail.caseData,
    allowEdit: state.detail.allowEdit,
    currentUser: state.home.currentUser,
    currentUsername: state.detail.currentUsername,
    isLockForEdit: state.detail.isLockForEdit,
    isToasterVisible: state.common.isToasterVisible,
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    saveAttachmentData: (
      file: any,
      uploadedBy: any,
      uniqueId: any,
      prevAttachmentData: any,
      type: string
    ) =>
      dispatch(
        actionSaveAttachmentData(
          file,
          uploadedBy,
          uniqueId,
          prevAttachmentData,
          type
        )
      ),
    downloadAttachment: (fileId: any) =>
      dispatch(actionDownloadAttachment(fileId)),
    deleteAttachment: (fileId: any, attachmentData: any, type: string) =>
      dispatch(actionDeleteAttachment(fileId, attachmentData, type)),
    openToaster: (message: string, success: boolean) =>
      dispatch(openToaster(message, success)),
    closeToaster: () => dispatch(closeToaster()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryForm);
